import { FeatureFlagType } from '~/enums/FeatureFlagType';
import { UserRoleType } from '~/enums/UserRoleType';
import { Permission } from '~/types/Permission';

import { and } from './utils/and';
import { not } from './utils/not';
import { testHasFlag } from './utils/testHasFlag';
import { testHasRole } from './utils/testHasRole';

export const canUseUpload: Permission = and([
  testHasFlag(FeatureFlagType.Upload),
  not(testHasRole(UserRoleType.WorkflowOnly)),
]);
